export const HamburgerMenu = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 22 20" {...props}>
    <path d="M1 3H21" stroke="#8084B3" strokeWidth="2" strokeLinecap="round" />
    <path d="M1 10H21" stroke="#8084B3" strokeWidth="2" strokeLinecap="round" />
    <path d="M1 17H21" stroke="#8084B3" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
